<i class="bp-mat-icon material-icons {{iconSize}}">{{bpMatIcon}}</i>
